module.exports = {
  tableBtn: [
    {
      id: 'edit',
      name: '修改用户',
      dataStatus: '1',
      isNoConfirm: true // 不需要弹窗询问
    },
    {
      id: 'resetPassword',
      name: '重置密码',
      dataStatus: '1',
      isNoConfirm: true // 不需要弹窗询问
    }
  ],
  tableHead: [
    {
      label: '序号',
      key: '$index',
      width: '60',
      fixed: true
    }, {
      label: '账户',
      key: 'account',
      fixed: true,
      linkKey: 'url'
    }, {
      label: '姓名',
      key: 'name',
      fixed: true
    }, {
      label: '手机号码',
      key: 'mobile'
    }, {
      label: '所属机构',
      key: 'affiliation'
    }, {
      label: '角色',
      key: 'role'
    }, {
      label: '状态',
      key: 'status'
    },
    {
      label: '最新修改时间',
      key: 'updateTime'
    }
  ],
  dialogForm: [
    {
      id: 'password',
      label: '密码',
      type: 'input',
      isVisible: false,
      inpType: 'password',
      visibleType: 'password',
      validateType: 'pass',
      clearable: true,
      width: '400px',
      modelHide: 'add'
    }, {
      id: 'checkPass',
      label: '确认密码',
      type: 'input',
      isVisible: false,
      inpType: 'password',
      visibleType: 'password',
      validateType: 'checkPass',
      clearable: true,
      width: '400px',
      modelHide: 'add'
    }
  ],
  dialogFormRules: {
    password: [
      {
        required: true,
        message: '请输入'
      },
      {
        min: 6,
        message: '必填，至少6个字符，可由数字、大写字母、小写字母或特殊字符组成',
        trigger: 'blur'
      },
      {
        pattern: '/^[^\\u4E00-\\u9FA5 ]+$/',
        message: '必填，至少6个字符，可由数字、大写字母、小写字母或特殊字符组成',
        trigger: 'change'
      }
    ]
  }
}
